<template>
	<div>
		<div class="footer page">
			<div class="footerContentWrap">
				<!-- 푸터 메뉴 -->
				<div class="footerMenusWrap">
					<ul class="menus">
						<!-- <li>개인정보처리방침</li> -->
						<li><router-link to="/cs">고객문의</router-link></li>
					</ul>
				</div>
				<div class="footerContent">
					<ul class="footerContentItems">
						<li class="footerTxtCont">대표이사 : 손영대</li>
						<li class="footerTxtCont">전화 : {{$store.state.basicInfo.phoneNm}}</li>
						<li class="footerTxtCont">주소 : {{$store.state.basicInfo.address}}</li>
						<li class="footerTxtCont">이메일 : {{$store.state.basicInfo.email}}</li>
						<li class="footerTxtCont">팩스 : {{$store.state.basicInfo.faxNm}}</li>
					</ul>
				</div>
				<div class="footerCopyright">© TWOSONSOFT. All Rights Resserved.</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	props: {}
}
</script>

<style scoped lang="scss">
@import '@/css/variables.scss';
.footer {
	background-color: $c-gray-dark;
	color: $c-white;
	.footerMenusWrap {
		.menus li {
			display: inline-block;
			margin-right: 40px;
			margin-bottom: 40px;
			font-weight: bold;
			color: $c-white;
			a {color: $c-white;}
		}
	}
	.footerContent {
		color: $c-gray-light2;
		.footerContentItems {
			.footerTxtCont {
				// line-height: 1.5em;
			}
		}
	}
	.footerCopyright {
		color: $c-gray-m;
		margin-top: 60px;
	}
}
@media (min-width: $mnWMobile) and (max-width: 480px) {
	.footer {
		padding: 24px 16px;
		.footerMenusWrap  {
			.menus li {
				margin-right: 24px;
				margin-bottom: 16px;
			}
		}
		.footerContent {
			.footerContentItems {
				.footerTxtCont {
					font-size: 14px;
				}
			}
	}
		.footerCopyright {
			margin-top: 16px;
			font-size: 14px;
		}
	}
}
</style>
